import { FC } from "react";

import { useCheckPermission } from "../../../../shared/Helpers/hooks";
import { AdminTypes } from "../../../../components/Menu";
import { PERMISSIONS } from "../../../../App/constants";
import Details from "./details";
import DownloadSOAPNote from "./download";
import Edit from "./edit";
import View from "./view";
import Unlock from "./unlock";

import { useSelector } from "../../../../redux/store";
import { SoapNotesFullProperties } from "../../../../redux/API/ClientAPIHelpers/soapNoteProperties";
import { SoapNotesStatuses } from "../../../../redux/API/ClientAPIHelpers/dataCollectionProperties";

const Actions: FC<{ data: SoapNotesFullProperties }> = ({ data }) => {
  const DOWNLOAD = useCheckPermission(PERMISSIONS.SOAPNOTE.PDF);
  const UNLOCK = useCheckPermission(PERMISSIONS.SOAPNOTE.UNLOCK);
  const EDIT = useCheckPermission(PERMISSIONS.SOAPNOTE.EDIT);

  const role = useSelector((state) => state.account.role);
  const userId = useSelector((state) => state.account.user.id);

  const { id, status } = data;

  const isExpired = status.status === SoapNotesStatuses.expiredWeek ||
    status.status === SoapNotesStatuses.expired48;

  const isEditable = status.status === SoapNotesStatuses.draft ||
    status.status === SoapNotesStatuses.unlocked;

  const isSubmitted = status.status === SoapNotesStatuses.submitted;
  const isPendingBt = status.status === SoapNotesStatuses.pendingBT;

  const canUserEdit = data.user.id === userId || role?.section.id === AdminTypes.admin;

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: "8px",
        cursor: "pointer",
      }}
    >
      <Details data={data} />
      {
        isExpired &&
        (role?.section.id === AdminTypes.admin ||
          role?.section.id === AdminTypes.bcba) && (
          <>
            {UNLOCK.permissionGranted && <Unlock reportId={id} />}
            <Edit data={data} isViewOnly={isExpired} />
          </>
        )
      }
      {
        isEditable &&
        EDIT.permissionGranted &&
        <Edit data={data} isViewOnly={!canUserEdit} />
      }
      {
        isSubmitted && (
          <>
            <View reportId={data.id} />
            {DOWNLOAD.permissionGranted && role?.section.id !== AdminTypes.bt && (
              <DownloadSOAPNote data={data} />
            )}
          </>
        )
      }
      {
        isPendingBt && (
          <View reportId={data.id} />
        )
      }
    </div>
  );
};

export default Actions;
